import * as React from 'react'
import {ISettings, IUser, IWorkMode} from '../models/users'

export interface SignUpData {
    phone: string
    password: string
    email: string
    entity: string
    city?: string
    inn?: string
    agreement_accepted: boolean
}

export interface ContextProps {
    user: IUser | null | false
    authenticated: null | boolean
    workMode: IWorkMode | null
    settings: ISettings | null
    signIn: (signInData: Record<string, never>) => Promise<Record<string, never>>
    signUp: (signUpData: SignUpData) => Promise<Record<string, never>>
    forgotPassword: (signUpData: Record<string, never>) => Promise<boolean>
    resetPassword: (signUpData: Record<string, never>) => Promise<boolean>
    signOut: () => void
    setUser: (user: IUser | null | false, authenticated?: boolean) => void
    setWorkMode: (workMode: IWorkMode) => void
    setSettings: (settings: ISettings) => void
    checkAuthentication: () => Promise<boolean>
    checkWorkMode: () => Promise<IWorkMode>
    checkSettings: () => Promise<ISettings>
    acceptAgreement: () => Promise<boolean>
}

const SanctumContext = React.createContext<Partial<ContextProps>>({})

export default SanctumContext
